import { FieldList, Radio, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslation } from '@hotjar/translations';

// todo: remove once insights.scss is gone
const StyledRadio = styled(Radio)`
  margin-bottom: 0 !important;
`;

const StyledFieldList = styled(FieldList)`
  margin-bottom: ${tokens.spacer.x2};
`;

export enum WIDGET_THEME {
  DARK = 'dark',
  LIGHT = 'light',
}

const options: { key: WIDGET_THEME; labelKey: string }[] = [
  { key: WIDGET_THEME.LIGHT, labelKey: 'light' },
  { key: WIDGET_THEME.DARK, labelKey: 'dark' },
];

export interface ThemeSelectorProps {
  theme: WIDGET_THEME;
  onChange: (newValue: WIDGET_THEME) => void;
}

export function AlternateColor({ theme, onChange }: ThemeSelectorProps): JSX.Element {
  const { t } = useTranslation('feedback');
  return (
    <StyledFieldList title={t('feedback-wizard.appearance.alt-color.label')} size="s">
      {options.map((option) => (
        <StyledRadio
          key={option.key}
          isChecked={theme === option.key}
          id={`widget-skin-${option.key}`}
          name={option.key}
          onChange={() => onChange(option.key)}
          value={option.key}
          labelContent={t(`feedback-wizard.appearance.alt-color.${option.labelKey}`)}
        />
      ))}
    </StyledFieldList>
  );
}
